import { formatCurrency } from 'helpers/utils'
import type { BackOfficeCustomerDtoV2, PersonDto } from '../api/swagger/definitions/backoffice'

export enum SmsBodyVariables {
  firstName = '#FirstName',
  lastName = '#LastName',
  fullName = '#FullName',
  companyName = '#CompanyName',
}

export interface SmsTemplate {
  createdAt: number
  deleted: boolean
  id: string
  modifiedAt: number
  rev: number
  text: string
  title: string
}

export const getFirstNameForSMS = (person: PersonDto | null | undefined) => {
  if (person) {
    return person.fullName.split(' ')[0]
  }
  return '-'
}

export const getLastNameForSMS = (person: PersonDto | null | undefined) => {
  if (person) {
    try {
      const splittedName = person.fullName.split(' ')
      splittedName.shift()
      return splittedName.join(' ')
    } catch (err) {
      return '-'
    }
  } else {
    return '-'
  }
}

export const getFullNameForSMS = (person: PersonDto | null | undefined) => {
  if (person) {
    return person.fullName
  }
  return '-'
}

export const getCompanyNameForSMS = (customer?: BackOfficeCustomerDtoV2) => {
  if (customer) {
    return customer.companyName
  }
  return '-'
}

export const formatSmsText = (body: string, person: PersonDto | null | undefined, customer?: BackOfficeCustomerDtoV2) =>
  body
    .replace(SmsBodyVariables.firstName, getFirstNameForSMS(person))
    .replace(SmsBodyVariables.lastName, getLastNameForSMS(person))
    .replace(SmsBodyVariables.fullName, getFullNameForSMS(person))
    .replace(SmsBodyVariables.companyName, getCompanyNameForSMS(customer))

const smsInterpolationHelpers = {
  getFirstNameForSMS,
  getLastNameForSMS,
  getFullNameForSMS,
  getCompanyNameForSMS,
  formatSmsText,
}

export default smsInterpolationHelpers
